import Create from './Create'
import CreateTrigger from './CreateTrigger'
import Thumbnail from './Thumbnail'
import Preview from './Preview'

export default {
  name: 'Vimeo',
  condition: x => {
    return /^vimeo/i.test(x.type)
  },
  components: {
    Create,
    CreateTrigger,
    Thumbnail,
    Preview,
  },
}
